import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { UPSERT_ASSET_MK } from '../components/UpsertAssetModal/UpsertAssetModal.meta';
import { queryKeys } from './queryKeys';
import { UpsertBusinessAssetDTO } from '../forms/BusinessAssets/BusinessAssetsForm.meta';

export const UPSERT_BUSINESS_ASSETS_ENDPOINT = '/Consumer/OtherAssetsUpdate/SaveBusinessAsset';

const upsertBusinessAsset = (body: UpsertBusinessAssetDTO): Promise<null> => {
  return authFetch(UPSERT_BUSINESS_ASSETS_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

interface Params {
  clientId: string;
}

export const useUpsertBusinessAssetsMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(upsertBusinessAsset, {
    mutationKey: [UPSERT_ASSET_MK, 'businessAsset'],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
